export const types = {
    SET_GET_OFFERS: '[OFFERS] SET GET OFFERS',
    SET_GET_OFFERS_BY_ID: '[OFFERS] SET GET OFFERS BY ID',
    SET_GET_OFFERS_BY_PARTNER: '[OFFERS] SET GET OFFERS BY PARTNER',
    SET_GET_GROUP_OFFERS: '[OFFERS] SET GET GROUP OFFERS'
}